<template>
  <div id="full-screen"
       class="full-screen animated fadeIn">
    <span class="close-arrow"
          @click="$root.$emit('closeFullScreen')" />
    <slot />
  </div>
</template>

<script>
export default {
  mounted() {
    document.body.classList.add('removeScroll')
  },
  destroyed() {
    document.body.classList.remove('removeScroll')
  }
}
</script>

<style lang="scss">
@import './full-screen.sass'
</style>
